import { render, staticRenderFns } from "./InternationalFlight.vue?vue&type=template&id=248dd748&scoped=true&"
import script from "./InternationalFlight.vue?vue&type=script&lang=js&"
export * from "./InternationalFlight.vue?vue&type=script&lang=js&"
import style0 from "./InternationalFlight.vue?vue&type=style&index=0&id=248dd748&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248dd748",
  null
  
)

export default component.exports